import api from '../../plugins/api';

// halykMarket â Ð²ÑÐ³ÑÑÐ¶Ð°ÑÑ Ð»Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ Ð½Ð° Ð¿Ð»Ð¾ÑÐ°Ð´ÐºÑ. ÐÐ»Ð¾ÑÐ°Ð´ÐºÐ° Ð¿ÑÐ¾ÑÐ¸Ñ Ð¿ÑÐ¸ÑÑÐ»Ð°ÑÑ Ð½Ðµ
// Ð²ÑÑ, Ð° Ð² Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ð¸ Ð¼Ð¾Ð´ÐµÐ»Ñ Ð¿ÑÐ¸ ÑÑÐ¾Ð¼ Ð½ÑÐ¶Ð½Ð°: Ð¿ÑÐ¸Ð·Ð½Ð°Ðº Ñ Ð¼Ð°ÑÐ¸Ð½Ñ (forApp) Ð¾Ð±ÑÐ¸Ð¹
// Ð´Ð»Ñ ÐºÐ°ÑÐ°Ð»Ð¾Ð³Ð° Ð¿ÑÐ¸Ð»Ð¾Ð¶ÐµÐ½Ð¸Ñ Ð¸ Ð²Ð¸ÑÑÐ¸Ð½Ñ Ð¥Ð°Ð»ÑÐºÐ°, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð²ÑÐºÐ»ÑÑÐ°ÑÐµÐ»Ñ Ð¾ÑÐ´ÐµÐ»ÑÐ½ÑÐ¹.
const editContainer = ({ containerId, photo, priceList, customPrice, halykMarket }) => {
  const formData = new FormData();
  formData.append('containerId', containerId);
  formData.append('photo', photo);
  formData.append('priceList', priceList);
  formData.append('customPrice', customPrice);
  if (halykMarket !== undefined) formData.append('halykMarket', halykMarket);

  return api.post('/api/crm/cars/editContainer', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export default editContainer;
